import PropTypes from 'prop-types';
import React from 'react';
import createReactClass from 'create-react-class';
import _ from 'lodash';
import { Col, Row } from 'react-bootstrap';
import { connect as connectR } from 'react-redux';
import LargeCard from '../main/large-card';
import translate from '../translate';

const ObjectStatisticsCard = createReactClass({
    displayName: 'ObjectStatisticsCard',

    propTypes: {
        stats: PropTypes.shape({
            turnover: PropTypes.number,
            wash_cycles: PropTypes.number,
            users: PropTypes.number,
        }).isRequired,
        strings: PropTypes.shape({
            turnover: PropTypes.string,
            users: PropTypes.string,
            wash_cycles: PropTypes.string,
        }).isRequired,
        selectedPartner: PropTypes.shape({}).isRequired,
    },

    defaultProps: {
        stats: { turnover: 0, wash_cycles: 0, users: 0 },
        strings: { turnover: '', users: '', wash_cycles: '' },
    },

    render() {
        const stats = _.extend({}, this.defaultProps.stats, this.props.stats);

        return (
            <LargeCard
                type="card-edit"
                title={[this.props.strings.title, this.props.strings.title2]}
            >
                <Row className="mt-10">
                    <Col xs={4}>
                        <div
                            data-toggle="tooltip"
                            data-placement="bottom"
                            title={this.props.strings.wonThisMonth}
                        >
                            <span className="icon icon-wew-calendar-euro-large icon-lg">
                                <i className="symbol">
                                    {this.props.strings._utils.getCurrencySymbolFromAccountingArea(
                                        this.props.selectedPartner
                                    )}
                                </i>
                            </span>
                            <div className="icon-label icon-label-lg">
                                {this.props.strings._utils.formatNumber(
                                    stats.turnover || 0,
                                    2
                                )}
                            </div>
                            <div className="icon-label">
                                {this.props.strings.wonThisMonth}
                            </div>
                        </div>
                    </Col>
                    <Col xs={4} className=" divider-lr">
                        <div
                            data-toggle="tooltip"
                            data-placement="bottom"
                            title={this.props.strings.numberOfUsers}
                        >
                            <span className="icon icon-wew-users-large icon-lg" />
                            <div className="icon-label icon-label-lg">
                                {stats.users || '0'}
                            </div>
                        </div>
                        <div className="icon-label">
                            {this.props.strings.numberOfUsers}
                        </div>
                    </Col>
                    <Col xs={4}>
                        <div
                            data-toggle="tooltip"
                            data-placement="bottom"
                            title={this.props.strings.numberOfCycles}
                        >
                            <span className="icon icon-wew-washmachine-large icon-lg" />
                            <div className="icon-label icon-label-lg">
                                {stats.wash_cycles || '0'}
                            </div>
                        </div>
                        <div className="icon-label">
                            {this.props.strings.numberOfCycles}
                        </div>
                    </Col>
                </Row>
            </LargeCard>
        );
    },
});

export default connectR((store) => ({
    selectedPartner: store.partnerManager.selectedPartner,
}))(translate('ObjectStatisticsCard')(ObjectStatisticsCard));
